import { render, staticRenderFns } from "./research.vue?vue&type=template&id=5d96e835&scoped=true"
import script from "./research.vue?vue&type=script&setup=true&lang=js"
export * from "./research.vue?vue&type=script&setup=true&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=5d96e835&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96e835",
  null
  
)

export default component.exports